/**
 * @description Примесь болезней.
 */
export default {
  data() {
    return {
      /**
       * @description Список диагнозов.
       * @type {Object[]}
       */
      diseaseTree: [],
      /**
       * @description Показывать диалог выбора болезни.
       * @type {boolean}
       */
      showDiseasesDialog: false,
    };
  },
  methods: {
    /**
     * @description Получить список категорий МКБ.
     * @returns {void}
     */
    async fetchDiseaseCategories() {
      const result = await this.$visitGateway.viewDiseaseCategoryList();
      result.forEach((list) => {
        this.diseaseTree = list;
      });
    },
    /**
     * @description Обработать загрузку списка дочерних диагнозов категории.
     * @param {Object} item
     * @returns {void}
     */
    async fetchDiseaseChildren(item) {
      const result = await this.$visitGateway.viewDiseaseCategoryList(item.id);
      result.forEach((list) => {
        item.children.push(...list[0].children);
      });
    },
  },
};
